import React from 'react'
import '../Styles/Section4.css'

export default function Section4() {
  return (
    <div className='section4'>
        <div className="section4container">
          <div className="sec4head">WHAT OUR DIRECTOR SAYS</div>
          <div className="sec4box">
            <div className="sec4img"> </div>
            <div className="sec4para">
              <i className="fa-solid fa-quote-left sec4icon"></i>
              <div className="sec4para1">I have myself faced financial hurdles while pursuing my education and, thus, want every student to have access to education without facing any monetary constraints.</div>
              <div className="sec4para2">Adv. Sharik Malik</div>
              <div className="sec4para3">Director, MD College<br/><i className=" sec4phoneicon fa-solid fa-phone"></i> &nbsp;&nbsp;  91-9084888555</div>
            </div>
          </div>
        </div>
    </div>
  )
}
<div className="contactchild"> 91-9627793111</div>
